// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m1Az","rootMobile":"styles_rootMobile__2pall"};